<template>
   <div class="PurchaseSettlement">
        <van-nav-bar
       title="买料结算"
       left-arrow
       fixed
       safe-area-inset-top
       placeholder 
       @click-left="leftClick"
        />
        <!-- 内容区域 -->
        <div class="content">
            <!-- 第一个内容区域 -->
                <div class="ctnOne">
                     <div class="zxjAccountNumber">
                         <h3>中鑫金指定收款账号</h3>
                         <div class="flex">
                                <div class="circular"></div>
                                <div class="text">{{BuyOrderList.payStatus == "WAIT"?'待付款':BuyOrderList.payStatus == "RAYED"?'已付款':'待确认'}}</div>
                         </div>
                     </div>
                     <div class="remarks margin">
                         如果您还未取货可前往约定指定料铺取货了喔！
                     </div>
                     <!-- 收款账户 -->
                     <div class="flex margin">
                         <div class="account flexLeftColor">收款账户：</div>
                         <div class="accountNumber flexRightColor" @click="copy(BuyOrderList.bankInfo.num)">{{BuyOrderList.bankInfo.num}}</div>
                     </div>
                     <!-- 收款银行 -->
                     <div class="flex margin">
                         <div class="account flexLeftColor">收款银行:</div>
                         <div class="accountNumber flexRightColor">{{BuyOrderList.bankInfo.bank}}</div>
                     </div>
                     <!-- 收款人 -->
                    <div class="flex margin">
                         <div class="account flexLeftColor">收款人:</div>
                         <div class="accountNumber flexRightColor">{{BuyOrderList.bankInfo.name}}</div>
                     </div>
                     <!-- 截图凭证 -->
                    <div class="flex margin jietu">
                         <h3>上传付款凭证截图 <van-icon name="arrow" /></h3>
                     </div>
                     <van-uploader v-model="fileList" multiple :max-count="3" :after-read="afterRead" :before-delete="beforeDelete">
                        <div class="upload">
                            <div class="shu"></div>
                            <div class="heng"></div>
                        </div>
                     </van-uploader>
                </div>
            <!-- 第二个内容区域 -->
            <div class="ctnTwo">
                    <h3>结算信息</h3>
                   
    
                             <!-- 结算时间 -->
                     <div class="flex margin">
                         <div class="account flexLeftColor">结算时间:</div>
                         <div class="accountNumber flexRightColor">{{BuyOrderList.created | formatDate_}}</div>
                     </div>
                        <!-- 结算单号 -->
                     <div class="flex margin">
                         <div class="account flexLeftColor">结算单号:</div>
                         <div class="accountNumber flexRightColor">{{BuyOrderList.openNo}}</div>
                     </div>
                        <!-- 订单数量 -->
                     <div class="flex margin orderContent">
                         <div class="account flexLeftColor">订单数量:</div>
                         <div class="accountNumber flexRightColor">{{BuyOrderList.itemList.length}}</div>
                     </div>
                     <div class="jieSuanOrder" v-for="(item,index) in BuyOrderList.itemList" :key="index">
                                     <!-- 订单编号 -->
                                 <div class="flex margin jieSuanTime">
                                     <div class="account flexLeftColor">订单编号:</div>
                                     <div v-if="item.orderId" class="accountNumber flexRightColor" @click="openOrderIdentifier(item.orderId)">{{item.orderId}}  <van-icon name="arrow" /></div>
                                     <div v-if="!item.orderId" class="accountNumber flexRightColor">现价结算</div>

                                 </div>
                                    <!-- 重量 -->
                                 <div class="flex margin">
                                     <div class="account flexLeftColor">重量(克):</div>
                                     <div class="accountNumber flexRightColor">{{item.weight.toFixed(1)}}</div>
                                 </div>
                                     <!-- 单价 -->
                                 <div class="flex margin">
                                     <div class="account flexLeftColor">单价(元/克):</div>
                                     <div class="accountNumber flexRightColor">{{item.price}}</div>
                                 </div>
                                     <!-- 金额 -->
                                 <div class="flex margin orderContent">
                                     <div class="account flexLeftColor">金额(元):</div>
                                     <div class="accountNumber flexRightColor">{{item.money}}</div>
                                 </div>
                     </div>
                     <!-- 合计 -->
                     <div class="flex margin total">
                         <h3 class="totalWeight">合计重量(克) <span>{{totalWeight.toFixed(1)}}</span> </h3>
                         <h3 class="totalMoney">合计金额(元) <span>{{totalMoney}}</span></h3>
                     </div>
            </div>
            <!-- 第三个区域内容 -->
            <div class="ctnThree">
                         <!-- 取货信息 -->
                    <div class="flex margin">
                         <h3>取货信息</h3>
                         <div class="accountNumber flexRightColor isFetched">{{BuyOrderList.fetchInfo.fetched?'已取货':'未取货'}}</div>
                     </div>
                     <!-- 取货方式 -->
                     <div class="flex margin">
                         <div class="account flexLeftColor">取货方式:</div>
                         <div class="accountNumber flexRightColor">{{BuyOrderList.fetchInfo.type == "PLACE"?'自取':'快递'}}</div>
                     </div>
                     <!-- 取货地址 -->
                     <div class="flex margin">
                         <div class="account flexLeftColor">地址:</div>
                         <div class="accountNumber flexRightColor">{{BuyOrderList.fetchInfo.address.address}}</div>
                     </div>
                     <!-- 取货人 -->
                     <div class="flex margin">
                         <div class="account flexLeftColor">取货码:</div>
                         <div class="accountNumber flexRightColor"></div>
                     </div>
                     <!-- 联系电话 -->
                     <div class="flex margin">
                         <div class="account flexLeftColor">联系电话:</div>
                         <div class="accountNumber flexRightColor">{{BuyOrderList.fetchInfo.address.phone}}</div>
                     </div>
                     <!-- 备注 -->
                     <div class="flex margin">
                         <div class="account flexLeftColor">备注:</div>
                         <div class="accountNumber flexRightColor">{{BuyOrderList.fetchInfo.remark}}</div>
                     </div>
                     <!-- 料部电话 -->
                     <div class="flex margin">
                         <div class="account flexLeftColor">料部电话:</div>
                         <div class="accountNumber flexRightColor">{{BuyOrderList.fetchInfo.servicePhone}}</div>
                     </div>
            </div>
        </div>
        <footer>说明:由于货款入账审核需要一定时间,如果您已付货款,只需耐心等待审核人员审核即可,任何疑问可直接拨打客服热线:4001-886-722</footer>
   </div>
</template>

<script>
import * as api from'@/utils/api'

export default {
    data() {
        return {
            // 绑定已经上传的文件列表
            fileList:[],
            openId:'',
            BuyOrderList:{},
            totalWeight:0,
            totalMoney:0
        }
    },
    methods:{
        // 订单编号按钮点击事件
        openOrderIdentifier(order){
            this.$router.push({
                name:'buyOrderParticulars',
                query:{order:order,}
            })
        },
        // before-delete 删除前的回调函数
        beforeDelete(){
            this.fileList=[]
        },
        // after-read 回调函数，获取到对应的 file 对象。
        async  afterRead(file){
            console.log(file);
              // 此时可以自行将文件上传至服务器
            let res = await api.getApiFile(this.fileList.length,file.file)
            console.log('1',res);
            let key  =[]
            res.forEach(item =>{
                    key.push(item.key)
            })
            console.log('key',key);
            let upload = await api.upLodaInfo(this.openId,{images:key})
        },
        // 封装方法获取买料结算单详情
        async  getBuyOrderList(){
            // 发请求获取数据
            let res = await api.getBuyOrderList(this.openId)
            console.log(res);
            // 声明 总量 和 总价的 变量
                let weightAll = 0
                let moneyAll = 0
                // 遍历数据赋值
             res.itemList.forEach((item)=>{
                 weightAll += item.weight
                 moneyAll += item.money
             })
             res.payedImages.forEach(i=>{
            console.log('i',i);
          this.fileList.push({url:i.url,isImage: true})  
        })
            //  将获取到数据赋值
            this.BuyOrderList = res
            this.totalWeight = weightAll
            this.totalMoney = moneyAll

        },
        // 顶部左侧按钮点击事件
        leftClick(){
            this.$router.back()
        },
        copy(txt){
                this.$copyText(txt).then(()=>{
                this.$toast('卡号已复制到剪贴板')
            })
        },
    },
    created(){
        // 页面加载获取路由传递的值 用来发请求获取买料结算单详情
        this.openId = this.$route.query.openId
        // 调用封装方法获取买料结算单详情
        this.getBuyOrderList()


        console.log('1',this.fileList);

    }
}
</script>

<style lang="scss" scoped>
::v-deep{
     .van-nav-bar{
        height: 100px;
        .van-nav-bar__content{
        line-height: 100px;
        height: 100px;
        .van-nav-bar__title{
            font-size: 40px;
        }
        .van-icon{
            font-size: 40px;
            color: #1e1e1e;
        }
        }
     }

     .van-uploader__preview-image {
             display: block;
             width: 140px;
             height: 150px;
             overflow: hidden;
     }
     .van-uploader__preview-delete {
             position: absolute;
             top: 0;
             right: 0;
             width: 30px;
             height: 30px;
             background-color: rgba(0,0,0,.7);
             border-radius: 0 0 0 30px;
     }
     .van-uploader__preview-delete-icon {
          position: absolute;
          top: 0;
          right: 0;
          color: #fff;
          font-size: 30px;
          -webkit-transform: scale(.5);
          transform: scale(.5);
     }
     .van-uploader__input-wrapper {
             width: 140px;
             height: 150px;
             border: 1px dotted #1A1A1A;
     }
}
.PurchaseSettlement{
    font-family: Microsoft YaHei;
    background-color: #f5f5f5;

}
.content{
    margin-top: 40px;
    width: 100%;
    padding-bottom: 40px;
    h3{
            font-size: 30px;
            color: #1A1A1A;
            position: relative;
        }
    .ctnThree{
        background-color: #fff;
        width: 100%;
        padding: 8px 40px;
        margin-top: 30px;
    }
    .ctnTwo{
        background-color: #fff;
        width: 100%;
        padding: 8px 40px;
        margin-top: 30px;
        h3{
            font-size: 30px;
            color: #1A1A1A;
            position: relative;
            left: -6px;
        }
        .orderContent{
            height: 70px;
            border-bottom: 3px solid #CCCCCC;
        }
        .jieSuanTime{
            margin-top: 30px;
                .van-icon{
                     position: relative;
                     top: 3px;
                     right: -3px;
                }
        }
        .total{
            padding: 0 100px 0 10px;
            span{
                font-size: 20px;
                color: #FBA306;
            }
        }
    }
    .ctnOne{
        background-color: #fff;
        width: 100%;
        padding: 8px 40px;
        .zxjAccountNumber{
            display: flex;
            justify-content: space-between;
            h3{
                font-size: 30px;
                color: #1A1A1A;
            }

        }
        .remarks{
            width: 100%;
            text-align: right;
            color: #CCCCCC;
            font-size: 14px;
        }
        .jietu{
            h3{
                color: #999999;
                font-size: 30px;
            }
        .van-icon{
         position: relative;
         top: 4px;
     }
        }
    }
}
footer{
    width: 100%;
    padding: 0 30px;
    color: #CCCCCC;
    // line-height: 43px;
    font-size: 16px;
}
// 弹性布局
.flex{
    display: flex;
    justify-content: space-between;
    .text{
        font-size: 30px;
        color: #fda405;
    }
}
// 圆形
.circular{
    width: 18px;
    height: 18px;
    background: #fda405;
    border-radius: 50%;
    position: relative;
    top: 50%;
    margin-top: -9px;
    margin-right: 8px;
}
// 外边距
.margin{
    margin: 18px 0;
}
// 内容左侧文字颜色
.flexLeftColor{
    color: #CCCCCC;
    font-size: 26px;
}
// 内容右侧文字颜色
.flexRightColor{
    font-size: 26px;
    color: #1a1a1a;
    text-align: right;
}
.isFetched{
    color: #fda405;
}
.upload{
    width: 140px;
    height: 150px;
    position: relative;
    .shu{
        width: 1px;
        height: 50px;
        background-color: #1A1A1A;
        position: absolute;
        top: 50%;
        left: 50%;
        margin-top: -25px;
    }
    .heng{
        width: 50px;
        height: 1px;
        background-color: #1A1A1A;
        position: absolute;
        top: 50%;
        left: 50%;
        margin-left: -25px;
    }
}
.remarks{
    font-size: 38px;
}
</style>